const ERROR_CLASS = 'is-danger';
const SUCCESS_CLASS = 'is-success';

class Input {
  constructor($element) {
    this.$element = $element;
    this.initEvents();
  }

  initEvents() {
    // Add a css class on submit when the input is invalid.
    this.$element.addEventListener('invalid', () => {
      this.$element.classList.add(ERROR_CLASS);
      this.$element.classList.remove(SUCCESS_CLASS);
    });

    // Remove the class when the input becomes valid.
    // 'input' will fire each time the user types
    this.$element.addEventListener('input', () => {
      if (this.$element.validity.valid) {
        this.$element.classList.remove(ERROR_CLASS);
        this.$element.classList.add(SUCCESS_CLASS);
      }
    });
  }
}

export default Input;



// WEBPACK FOOTER //
// ./js/components/form/input.js